"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ErrorMessage = _interopRequireDefault(require("../../ErrorMessage"));

var _Item = _interopRequireDefault(require("../Item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = _styledComponents.default.div(_templateObject());

Container.displayName = 'Container';
/* istanbul ignore next */

var getName = function getName(_ref) {
  var _ref$firstName = _ref.firstName,
      firstName = _ref$firstName === void 0 ? '' : _ref$firstName,
      _ref$lastName = _ref.lastName,
      lastName = _ref$lastName === void 0 ? '' : _ref$lastName;
  return (firstName + " " + lastName).trim();
};

var DisplayFilter = function DisplayFilter(_ref2) {
  var users = _ref2.users,
      filter = _ref2.filter,
      _onClick = _ref2.onClick;
  var filtered = users.filter(function (user) {
    return getName(user).toLowerCase().includes(filter.trim().toLowerCase());
  });
  return _react.default.createElement(Container, null, filtered.length ? filtered.map(function (_ref3) {
    var id = _ref3.id,
        firstName = _ref3.firstName,
        lastName = _ref3.lastName,
        other = _objectWithoutPropertiesLoose(_ref3, ["id", "firstName", "lastName"]);

    return _react.default.createElement(_Item.default, _extends({
      key: id,
      name: getName({
        firstName: firstName,
        lastName: lastName
      }),
      onClick: function onClick() {
        return _onClick(id);
      }
    }, other));
  }) : _react.default.createElement(_ErrorMessage.default, null, "No results found"));
};

DisplayFilter.displayName = 'DisplayFilter';
DisplayFilter.propTypes = {
  users: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]).isRequired,
    firstName: _propTypes.string,
    lastName: _propTypes.string,
    selected: _propTypes.bool,
    warning: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
  })),
  filter: _propTypes.string,
  onClick: _propTypes.func.isRequired
};
DisplayFilter.defaultProps = {
  users: [],
  filter: ''
};
var _default = DisplayFilter;
exports.default = _default;